import styled from 'styled-components';

import { getColor, getSpace, hideVisually } from '@stylesheets/tools';
import { getGradientOutline } from '../../wishes.style';

const StyledWishRadio = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  input[type='radio'] {
    ${hideVisually()};
    position: absolute;
  }

  label {
    position: relative;
    border: 2px solid ${getColor('black')};
    border-radius: 4px;
    cursor: pointer;

    span {
      position: relative;
      background: ${getColor('white')};
      border-radius: 4px;
      padding: ${getSpace('xxxxs')} ${getSpace('xxxs')};
      text-transform: uppercase;
      margin-bottom: 0;
    }
  }

  input[type='radio'] + label {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  input[type='radio']:checked + label {
    border-color: transparent;
    ${getGradientOutline()};
  }
`;

export default StyledWishRadio;
